import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/images/ImageBulkActionList.js";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import Util from "../../util/Util";
import { Dialog, Pagination, SimpleSnackbar } from "../common";
import { AUDIT_ACTION, BASE_URIS, BULK_ACTIONS, LOCAL_STORAGE_ITEM_NAMES, PUBLISH_ACTION, PUBLISH_STATUS, Q_STRING, TPIS_PARAMS } from "../domain/constants";
import { Table, TableHead, TableBody, TableRow, TableCell, Grid, Typography, Button, Checkbox, LinearProgress, TextField } from '@material-ui/core';
import queryString from "query-string";
import { changeSearchValue, setUpPageInfoFromQueryString, determinePageSize } from "../../util/QueryStringUtil";
import PublishFailureTable from "./PublishFailureTable";
const styles = theme => ({
  img: {
    display: 'block',
    maxWidth: '30vh',
    maxHeight: '30vh',
    width: 'auto',
    height: 'auto'
  },
  root: {
    width: '100%',
    marginTop: 0,
    overflowX: 'auto'
  },
  cell: {
    padding: 15,
    margin: 15
  },
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    width: '80%'
  },
  button: {
    margin: theme.spacing(1)
  }
});
class ImageBulkActionList extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "addAuditNotes", itemId => event => {
      const auditNotes = this.state.auditNotes;
      auditNotes[itemId] = event.target.value;
      this.forceUpdate();
    });
    _defineProperty(this, "handleChange", itemId => event => {
      const selectedImageIndexes = this.state.selectedImageIndexes;
      selectedImageIndexes[itemId] = event.target.checked;
      this.forceUpdate();
    });
    const querystringValues = queryString.parse(this.props.location.search);
    const pageSize = determinePageSize(querystringValues, props);
    this.state = {
      action: props.action ? props.action : BULK_ACTIONS.AUDIT,
      baseUri: props.baseUri != null ? props.baseUri : null,
      images: [],
      selectedImageIndexes: {},
      auditNotes: {},
      loaded: false,
      morePages: true,
      totalPages: 0,
      totalElements: 0,
      page: 0,
      pageSize: pageSize,
      failures: null,
      description: null
    };
    this.loadContent();
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
    this.snackbar = null;
    this.setSnackbarRef = element => {
      this.snackbar = element;
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    setUpPageInfoFromQueryString(this);
  }
  loadContent() {
    this.state.loaded = false;
    this.state.images = [];
    this.state.auditNotes = {};
    this.state.selectedImageIndexes = {};
    this.state.morePages = true;
    this.forceUpdate();
    const uri = this.makeUri();
    Util.fetchWithRedirect(uri, 'GET', this.props).then(result => {
      const content = result.content;
      this.addToImagesFromAssociationsCall(content);
      this.setState({
        loaded: true,
        morePages: !result.last,
        totalPages: result.totalPages,
        totalElements: result.totalElements
      });
    }).catch(e => {
      Util.log('ImageBulkActionList.loadContent', true, e, false);
      this.setState({
        loaded: true,
        e
      });
    });
  }
  addToImagesFromAssociationsCall(newContent) {
    const _this$state = this.state,
      auditNotes = _this$state.auditNotes,
      selectedImageIndexes = _this$state.selectedImageIndexes;
    newContent.forEach((association, index) => {
      let image = association.image;
      let entityProvider = association.entityProvider;
      let entityId = association.entityId;
      let bulkActionListItem = {
        id: image.id,
        url: image.url,
        entityId,
        entityProvider
      };
      if (image.auditDescription != null && image.auditDescription !== '') {
        auditNotes[image.id] = image.auditDescription;
      }
      selectedImageIndexes[index] = false;
      this.state.images.push(bulkActionListItem);
    });
  }
  render() {
    const classes = this.props.classes;
    const selectedImageIndexes = this.state.selectedImageIndexes;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '40vh',
        minWidth: '80vw',
        marginTop: 0
      },
      className: classes.root,
      id: "table-eid-".concat(this.state.entityId),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 171,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 173,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      autoHideSeconds: 6,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 17
      }
    }), this.state.loaded === true && this.state.totalElements > 0 && this.selectButtons(classes), Pagination(this.state, this, classes, true), /*#__PURE__*/React.createElement(PublishFailureTable, {
      id: JSON.stringify(this.state),
      key: JSON.stringify(this.state),
      failures: this.state.failures,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 179,
        columnNumber: 17
      }
    }), this.state.loaded === true && this.state.images != null && this.state.images.length > 0 && /*#__PURE__*/React.createElement(Table, {
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(TableHead, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 184,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 185,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186,
        columnNumber: 29
      }
    }, "Select"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 187,
        columnNumber: 29
      }
    }, "Image"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 29
      }
    }, "Provider/Entity ID"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 189,
        columnNumber: 29
      }
    }, "Audit Notes"))), /*#__PURE__*/React.createElement(TableBody, {
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 192,
        columnNumber: 21
      }
    }, this.state.images.map((item, index) => /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 194,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 195,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: selectedImageIndexes[index],
      onChange: this.handleChange(index),
      color: "primary",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 37
      }
    })), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 202,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: item.url,
      target: "_blank",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 203,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item.url,
      alt: item.url,
      className: classes.img,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 41
      }
    }))), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 207,
        columnNumber: 33
      }
    }, this.displayIds(item)), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 208,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "outlined-multiline-static",
      label: "Audit Notes",
      multiline: true,
      rows: "4",
      value: this.state.auditNotes[item.id],
      placeholder: "Any notes to accompany audit decision (optional)",
      className: classes.textField,
      margin: "normal",
      variant: "outlined",
      onChange: this.addAuditNotes(item.id),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 209,
        columnNumber: 37
      }
    })))))), this.state.loaded === false && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "column",
      alignItems: "center",
      alignContent: "center",
      justify: "center",
      spacing: 8,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 223,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: "center",
      alignItems: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 225,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 226,
        columnNumber: 25
      }
    }, this.state.description)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: "center",
      alignItems: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 228,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(LinearProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 229,
        columnNumber: 25
      }
    }))), this.state.loaded === true && this.state.totalElements === 0 && /*#__PURE__*/React.createElement(Typography, {
      align: 'center',
      component: "div",
      style: {
        padding: 8 * 3
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 234,
        columnNumber: 17
      }
    }, "There are no more images to ", this.state.action), Pagination(this.state, this, classes, false), this.state.loaded === true && this.state.totalElements > 0 && this.selectButtons(classes));
  }
  selectButtons(classes) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.centeredContainer,
      style: {
        marginTop: '1vh'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 247,
        columnNumber: 13
      }
    }, !this.getSelected(true).allAreSelected && /*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      color: 'primary',
      className: classes.button,
      onClick: () => this.selectAll(true),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 17
      }
    }, "Select All"), this.getSelected(true).allAreSelected && /*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      color: 'primary',
      className: classes.button,
      onClick: () => this.selectAll(false),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253,
        columnNumber: 17
      }
    }, "Deselect All"), this.state.action === BULK_ACTIONS.PUBLISH && /*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      color: 'primary',
      className: classes.button,
      onClick: () => this.doBulkAction(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 257,
        columnNumber: 17
      }
    }, "Publish Selected"), this.state.action === BULK_ACTIONS.AUDIT && [/*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      color: 'primary',
      className: classes.button,
      onClick: () => this.doBulkAction(AUDIT_ACTION.accept),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 261,
        columnNumber: 21
      }
    }, "Accept Selected"), /*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      color: 'primary',
      className: classes.button,
      onClick: () => this.doBulkAction(AUDIT_ACTION.reject),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 263,
        columnNumber: 21
      }
    }, "Reject Selected")]);
  }

  /**
   * @param select true if should select all, false if should deselect all
   */
  selectAll(select) {
    const selectedImageIndexes = this.state.selectedImageIndexes;
    for (let i of Object.keys(selectedImageIndexes)) {
      selectedImageIndexes[i] = select;
    }
    this.forceUpdate();
  }
  async doBulkAction(auditAction) {
    const selected = this.getSelected(false);
    const amountToBulk = selected.amtSelected;
    this.state.loaded = false;
    this.forceUpdate();
    const _this$state2 = this.state,
      selectedImageIndexes = _this$state2.selectedImageIndexes,
      auditNotes = _this$state2.auditNotes;
    const failures = [];
    let curr = 1;
    let description;
    for (let index of Object.keys(selectedImageIndexes)) {
      if (selectedImageIndexes[index] === true) {
        description = "".concat(BULK_ACTIONS.AUDIT === this.state.action ? 'Auditing' : 'Publishing', " ").concat(curr, " of ").concat(amountToBulk);
        this.state.description = description;
        this.forceUpdate();
        const image = this.state.images[index];
        let uri = BASE_URIS.prefix + (BULK_ACTIONS.PUBLISH === this.state.action ? BASE_URIS.publish : BASE_URIS.audit) + "?".concat(TPIS_PARAMS.IMAGE_ID, "=").concat(image.id) + '&action=' + (BULK_ACTIONS.PUBLISH === this.state.action ? PUBLISH_ACTION.publish : auditAction) + "&".concat(TPIS_PARAMS.PROVIDER, "=").concat(image.entityProvider) + "&".concat(TPIS_PARAMS.ENTITY_ID, "=").concat(image.entityId);
        if (BULK_ACTIONS.AUDIT === this.state.action) {
          const imageAuditNotes = auditNotes[image.id];
          if (imageAuditNotes != null && imageAuditNotes !== '') {
            uri += "&".concat(TPIS_PARAMS.DESCRIPTION, "=").concat(imageAuditNotes);
          }
        }
        await Util.fetchWithRedirect(uri, 'POST', this.props).then(resp => {
          if (BULK_ACTIONS.PUBLISH === this.state.action) {
            this.pushAnyFailures(resp, failures);
          }
        }).catch(e => {
          Util.log('ImageBulkActionList.doBulkAction', true, e, true);
        });
        curr++;
      }
    }
    if (failures.length > 0) {
      this.state.failures = failures;
    }
    if (selected.allAreSelected === true) {
      if (this.state.page > 0) {
        this.state.page = this.state.page - 1;
        changeSearchValue(Q_STRING.PAGE, this.state.page + 1, this.props);
      }
      this.loadContent();
    } else {
      this.loadContent();
    }
  }
  pushAnyFailures(resp, failures) {
    const status = resp.status;
    if (status != null) {
      if (status.associations != null) {
        for (let assoc of status.associations) {
          if (assoc.publishStatus != null && assoc.publishStatus === PUBLISH_STATUS.failed) {
            failures.push({
              type: 'association',
              imageId: assoc.imageId,
              entityId: assoc.entityId,
              reason: assoc.publishDescription
            });
          }
        }
      }
      if (status.images != null) {
        for (let image of status.images) {
          if (image.publishStatus != null && image.publishStatus === PUBLISH_STATUS.failed) {
            failures.push({
              type: 'image',
              imageId: image.id,
              reason: assoc.publishDescription
            });
          }
        }
      }
    }
  }
  getSelected(shortCircuit) {
    const selectedImageIndexes = this.state.selectedImageIndexes;
    let allAreSelected = true;
    let amtSelected = 0;
    for (let i of Object.keys(selectedImageIndexes)) {
      if (selectedImageIndexes[i] === false) {
        allAreSelected = false;
        if (shortCircuit === true) {
          return {
            allAreSelected
          };
        }
      } else {
        amtSelected++;
      }
    }
    return {
      allAreSelected,
      amtSelected
    };
  }
  displayIds(item) {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      direction: 'column',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 391,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 6,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 392,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 393,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement("strong", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 393,
        columnNumber: 55
      }
    }, "Provider:"), " ", item.entityProvider)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 6,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 395,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 396,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement("strong", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 396,
        columnNumber: 55
      }
    }, "EntityId:"), " ", item.entityId)));
  }
  makeUri() {
    let uri = BASE_URIS.prefix + this.state.baseUri + "?".concat(TPIS_PARAMS.PAGE, "=").concat(this.state.page) + "&".concat(TPIS_PARAMS.PAGE_SIZE, "=").concat(this.state.pageSize);
    if (this.state.action === BULK_ACTIONS.AUDIT) {
      uri += TPIS_PARAMS.AUDIT_PENDING;
    } else if (this.state.action === BULK_ACTIONS.PUBLISH) {
      uri += TPIS_PARAMS.PUBLISH_PENDING;
    }
    if (this.state.baseUri === BASE_URIS.listAssociations) {
      uri += TPIS_PARAMS.INCLUDE_IMAGE;
    } else if (this.state.baseUri === BASE_URIS.listImages) {
      uri += TPIS_PARAMS.INCLUDE_ASSOCIATIONS;
    }
    return uri;
  }
}
export default withStyles(styles)(withRouter(ImageBulkActionList));